import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, SubmissionError } from "redux-form";
import _ from "lodash";
import moment from "moment";
import Button from "react-bootstrap-button-loader";
import Select from "react-select-plus";
import reactCSS from "reactcss";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  closeBooth,
  updateBoothColor,
  saveBooth,
  addBoothLink,
  deleteBooth,
  updateBooth,
  addBoothData,
  fetchInteractiveMapLocationSessionLinkWithEvventID,
} from "InteractiveMapAction";
import ColorPicker from "./colorpicker";
import BoothLink from "./boothlink";
import LocaleStrings from "Languages";

var defaultBoothColor = "#4da1ff";
const checkFromArr = ["exhibitor", "sponsor", "schedule", "speaker"];
let hideFeatures = [];
class BoothEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      displayColorPicker: false,
      color: this.hexToRgbA(props.booth.color),
      links: [],
    };
  }

  componentDidMount() {
    let { session } = this.props;

    /* Will use this to fetch data from "interactivemaplocation_session_link" 
    and remove this datas from "Search & Link with Booth" for session only
    */
    this.props.fetchInteractiveMapLocationSessionLinkWithEvventID(
      session,
      (callback) => {}
    );

    this.prepareLinksFromProps();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.boothLinkToDelete && nextProps.boothLinkToDelete.islocal) {
      var updatedBoothLinks = this.state.links.filter(
        (link) => link !== nextProps.boothLinkToDelete
      );
      this.setState({ links: updatedBoothLinks });
    } else if (nextProps.boothLinkToDelete) {
      var updatedBoothLinks = this.state.links.filter(
        (link) => link.linkid !== nextProps.boothLinkToDelete.linkid
      );
      this.setState({ links: updatedBoothLinks });
    }
  }

  prepareLinksFromProps() {
    if (!this.props.toAddNewBooth) {
      var links = [];

      if (
        this.props.selectedMap
          .interactivemaplocation_exhibitor_link_by_interactivemapid
      ) {
      } else {
        return false;
      }

      var exhibitors_link_for_location =
        this.props.selectedMap.interactivemaplocation_exhibitor_link_by_interactivemapid.filter(
          (link) => link.locationid === this.props.booth.locationid
        );

      var exhibitors = [];
      this.props.selectedMap.exhibitors_by_interactivemaplocation_exhibitor_link.map(
        (exhibitor) => {
          var added = false;
          var linkid = "";
          exhibitors_link_for_location.map((link) => {
            if (link.exhibitorid === exhibitor.exhibitorid) {
              added = true;
              linkid = link.linkid;
            }
          });
          var alreadyAdded = _.findIndex(exhibitors, exhibitor) !== -1;
          if (added && !alreadyAdded) exhibitors.push({ ...exhibitor, linkid });
        }
      );

      exhibitors.map((exhibitor) => {
        links.push({ ...exhibitor, type: "exhibitor" });
      });

      var speakers_link_for_location =
        this.props.selectedMap.interactivemaplocation_speaker_link_by_interactivemapid.filter(
          (link) => link.locationid === this.props.booth.locationid
        );

      var speakers = [];
      this.props.selectedMap.speaker_by_interactivemaplocation_speaker_link.map(
        (speaker) => {
          var added = false;
          var linkid = "";
          speakers_link_for_location.map((link) => {
            if (link.speakerid === speaker.speakerid) {
              added = true;
              linkid = link.linkid;
            }
          });
          var alreadyAdded = _.findIndex(speakers, speaker) !== -1;
          if (added && !alreadyAdded) speakers.push({ ...speaker, linkid });
        }
      );

      speakers.map((speaker) => {
        links.push({ ...speaker, type: "speaker" });
      });

      var sponsors_link_for_location =
        this.props.selectedMap.interactivemaplocation_sponsor_link_by_interactivemapid.filter(
          (link) => link.locationid === this.props.booth.locationid
        );

      var sponsors = [];
      this.props.selectedMap.sponsor_by_interactivemaplocation_sponsor_link.map(
        (sponsor) => {
          var added = false;
          var linkid = "";
          sponsors_link_for_location.map((link) => {
            if (link.sponsorid === sponsor.sponsorid) {
              added = true;
              linkid = link.linkid;
            }
          });
          var alreadyAdded = _.findIndex(sponsors, sponsor) !== -1;
          if (added && !alreadyAdded) sponsors.push({ ...sponsor, linkid });
        }
      );

      sponsors.map((sponsor) => {
        links.push({ ...sponsor, type: "sponsor" });
      });

      /* Session Link for location [ WILL UNCOMMENT ON NEXT BUILD ] */
      var sessions_link_for_location =
        this.props.selectedMap.interactivemaplocation_session_link_by_interactivemapid.filter(
          (link) => link.locationid === this.props.booth.locationid
        );

      var sessions = [];

      this.props.selectedMap.session_by_interactivemaplocation_session_link.map(
        (session) => {
          var added = false;
          var linkid = "";
          sessions_link_for_location.map((link) => {
            if (link.sessionid === session.sessionid) {
              added = true;
              linkid = link.linkid;
            }
          });
          var alreadyAdded = _.findIndex(sessions, session) !== -1;
          if (added && !alreadyAdded) sessions.push({ ...session, linkid });
        }
      );

      sessions.map((session) => {
        links.push({ ...session, type: "session" });
      });

      setTimeout(() => {
        this.setState({ links });
      }, 200);
    }
  }

  hexToRgbA(hex) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return { r: (c >> 16) & 255, g: (c >> 8) & 255, b: c & 255, a: 1 };
    }

    return { r: "77", g: "161", b: "255", a: "1" };
  }

  onCancel(e) {
    //If we are adding a new booth and user cancels the booth should be removed from the map
    if (this.props.toAddNewBooth) this.props.closeBooth(this.props.booth);
    else this.props.closeBooth();

    this.props.addBoothData({});
  }

  onFormSubmit(values) {
    values.locationname = values.locationname.trim();
    values.boothno = values.boothno.trim();

    this.setState({ loading: true });
    var valuesToSubmit = {};
    if (this.props.toAddNewBooth) {
      valuesToSubmit = {
        resource: [
          {
            locationname: values.locationname,
            color: values.color,
            boothno: values.boothno,
            interactivemapid: this.props.selectedMap.interactivemapid,
            location_x: this.props.booth.location_x,
            location_y: this.props.booth.location_y,
            location_width: this.props.booth.location_width,
            location_height: this.props.booth.location_height,
            eventid: this.props.session.eventid,
          },
        ],
      };
      var speakers = [];
      var exhibitors = [];
      var sponsors = [];
      var sessions = []; // Session Related Changes
      this.state.links.map((link) => {
        if (link.type === "session") {
          /* Session Related Changes */
          sessions.push({
            interactivemapid: this.props.selectedMap.interactivemapid,
            sessionid: link.sessionid,
            eventid: this.props.session.eventid,
          });
        } else if (link.type === "speaker") {
          speakers.push({
            interactivemapid: this.props.selectedMap.interactivemapid,
            speakerid: link.speakerid,
            eventid: this.props.session.eventid,
          });
        } else if (link.type === "sponsor") {
          sponsors.push({
            interactivemapid: this.props.selectedMap.interactivemapid,
            sponsorid: link.sponsorid,
            eventid: this.props.session.eventid,
          });
        } else {
          exhibitors.push({
            interactivemapid: this.props.selectedMap.interactivemapid,
            exhibitorid: link.exhibitorid,
            eventid: this.props.session.eventid,
          });
        }
      });

      if (speakers.length > 0) {
        valuesToSubmit = {
          ...valuesToSubmit,
          speaker: { resource: speakers },
          eventid: this.props.session.eventid,
        };
      }

      if (sponsors.length > 0) {
        valuesToSubmit = {
          ...valuesToSubmit,
          sponsor: { resource: sponsors },
          eventid: this.props.session.eventid,
        };
      }

      if (exhibitors.length > 0) {
        valuesToSubmit = {
          ...valuesToSubmit,
          exhibitor: { resource: exhibitors },
          eventid: this.props.session.eventid,
        };
      }

      /* Session Related Changes */
      if (sessions.length > 0) {
        valuesToSubmit = {
          ...valuesToSubmit,
          session: { resource: sessions },
          eventid: this.props.session.eventid,
        };
      }

      this.props.saveBooth(
        this.props.session,
        valuesToSubmit,
        this.props.selectedMap.interactivemapid,
        () => {
          setTimeout(() => {
            this.setState({ loading: false });
            this.props.closeBooth();
          }, 3000);
        },
        () => {
          this.setState({ loading: false });
        }
      );
    } else {
      valuesToSubmit = {
        resource: [
          {
            locationname: values.locationname,
            color: values.color,
            boothno: values.boothno,
            interactivemapid: this.props.selectedMap.interactivemapid,
            location_x: this.props.booth.location_x,
            location_y: this.props.booth.location_y,
            locationid: this.props.booth.locationid,
            eventid: this.props.session.eventid,
          },
        ],
      };
      this.props.updateBooth(
        this.props.session,
        valuesToSubmit,
        this.props.selectedMap.interactivemapid,
        () => {
          setTimeout(() => {
            this.setState({ loading: false });
            this.props.closeBooth();
          }, 1000);
        },
        () => {
          this.setState({ loading: false });
        }
      );
    }
  }

  renderOptions() {
    var optionItems = ["1", "2", "3", "4", "5", "6"];
    var options = optionItems.map((object, i) => (
      <option key={i} value={object}>
        {object}
      </option>
    ));

    return options;
  }

  renderSelectPicker(field) {
    var labelposition = field.labelposition;
    var divClassName = `form-group-map formdiv-map ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName}`;
    return (
      <div className={divClassName}>
        <label className="control-label-top col-sm-12">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className="col-sm-12 col-sm-offset-0">
          <Select
            className="react-multi-select-custom-css booth-select-plus"
            placeholder={field.label}
            options={field.opts}
            clearable={false}
            {...field.input}
            onBlur={() => {
              field.input.onBlur(field.input.value);
            }}
            isClearable
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderFieldText(field) {
    var labelposition = field.labelposition;
    var formdiv = "";
    if (field.formdiv !== undefined && field.formdiv === "false") {
      formdiv = "";
    }
    var divClassName = `form-group-map formdiv-map ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  renderColorTextField(field) {
    var divClassName = `form-group-map formdiv-map ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName}`;
    var labelClasses = "control-label-top col-sm-12";
    var inputClasses = "col-sm-12 col-sm-offset-0 d-flex";

    return (
      <>
        <div className={divClassName}>
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
          <div className={inputClasses}>
            <div style={field.styles.swatch}>
              <button
                style={field.styles.color}
                type="button"
                onClick={field.managePicker}
              ></button>
            </div>
            <input
              className="form-control booth-color-text"
              type={field.type}
              placeholder={field.placeholder}
              {...field.input}
              readOnly={true}
            />
            <div className="text-help label-text-help">
              {field.meta.touched ? field.meta.error : ""}
            </div>
          </div>
        </div>
        {/* <div style={{ height: 31 }}></div> */}
      </>
    );
  }

  handlePickerChange(color) {
    this.setState({ color: color.rgb });
    this.props.change("color", color.hex);
    //Update the color of the booth as it changes
    var updatedBooth = { ...this.props.booth, color: color.hex };
    this.props.updateBoothColor(updatedBooth);
  }

  handlePickerClose() {
    this.setState({ displayColorPicker: false });
  }

  handlePickerClick() {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  }

  renderOptions() {
    let hideSessions = false;
    let hideSponsors = false;
    let hideSpeakers = false;
    let hideExhibitors = false;

    let { interactivemaplocationsession, selectedFeatures, userEventDetails } =
      this.props;

    if (selectedFeatures && selectedFeatures.length > 0) {
      /* Feature list exsist , check which to hide in 'Link with Booth' */
      hideFeatures = _.filter(selectedFeatures, function (o) {
        return o.isenabled === false && checkFromArr.indexOf(o.bsClass) !== -1;
      });
    }

    // debugger;
    var links = this.state.links;

    var exhibitors = [];
    var availableExhibitors = [];

    //Filtering out the already added links from options...
    this.props.boothlinks.exhibitors_by_eventid.map((exhibitor) => {
      var added = false;
      links.map((object) => {
        if (object.exhibitorid === exhibitor.exhibitorid) added = true;
      });
      if (!added) {
        availableExhibitors.push(exhibitor);
      }
    });

    availableExhibitors.map((exhibitor) =>
      exhibitors.push({
        value: { ...exhibitor, type: "exhibitor" },
        label: exhibitor.name,
      })
    );

    var speakers = [];
    var availableSpeakers = [];

    this.props.boothlinks.speaker_by_eventid.filter((speaker) => {
      var added = false;
      links.map((object) => {
        if (object.speakerid === speaker.speakerid) added = true;
      });
      if (!added) {
        availableSpeakers.push(speaker);
      }
    });

    availableSpeakers.map((speaker) =>
      speakers.push({
        value: { ...speaker, type: "speaker" },
        label: `${speaker.firstname} ${speaker.lastname}`,
      })
    );

    var sponsors = [];
    var availableSponsors = [];

    this.props.boothlinks.sponsor_by_eventid.filter((sponsor) => {
      var added = false;
      links.map((object) => {
        if (object.sponsorid === sponsor.sponsorid) added = true;
      });
      if (!added) {
        availableSponsors.push(sponsor);
      }
    });

    availableSponsors.map((sponsor) =>
      sponsors.push({
        value: { ...sponsor, type: "sponsor" },
        label: sponsor.name,
      })
    );

    /* Session  Starts [ WILL UNCOMMENT ON NEXT BUILD ] */
    var sessions = [];

    var availableSessions = [];

    let eventStartDate = moment(userEventDetails.eventstartdate).format(
      "YYYY-MM-DD"
    );

    let eventEndDate = moment(userEventDetails.eventenddate).format(
      "YYYY-MM-DD"
    );

    this.props.boothlinks.session_by_eventid.filter((session, index) => {
      let sessionStarttime = moment(session.starttime).format("YYYY-MM-DD");

      if (
        // Session validation []
        moment(sessionStarttime).isBefore(eventStartDate) ||
        moment(sessionStarttime).isAfter(eventEndDate)
      ) {
        // Dont include those session in not under event start and end date
      } else {
        // ALl ok in this range
        var added = false;
        links.map((object, index) => {
          if (object.sessionid === session.sessionid) added = true;
        });
        if (!added) {
          availableSessions.push(session);
        }
      }
    });

    availableSessions.map((session, index) => {
      /* Dont show if session is already tag under any map  */
      if (interactivemaplocationsession.length > 0) {
        if (
          _.findIndex(interactivemaplocationsession, function (o) {
            return o.sessionid == session.sessionid;
          }) > -1
        ) {
          // Dont take this value
        } else {
          // Take this value if does not match
          sessions.push({
            value: { ...session, type: "session" },
            label: session.title,
          });
        }
      } else {
        // Show all if not map associated
        sessions.push({
          value: { ...session, type: "session" },
          label: session.title,
        });
      }
    });

    /* Session  Ends*/

    /* If features are not available then dont show that featur on "Search & Link with Booth [input box]"  */

    var options = [];

    if (
      exhibitors.length > 0 &&
      _.findIndex(hideFeatures, ["bsClass", "exhibitor"]) === -1
    ) {
      options.push({ label: "Exhibitors", options: exhibitors });
    }

    if (
      speakers.length > 0 &&
      _.findIndex(hideFeatures, ["bsClass", "speaker"]) === -1
    ) {
      options.push({ label: "Speakers", options: speakers });
    }

    if (
      sponsors.length > 0 &&
      _.findIndex(hideFeatures, ["bsClass", "sponsor"]) === -1
    ) {
      options.push({ label: "Sponsors", options: sponsors });
    }

    // Session related [ WILL UNCOMMENT ON NEXT BUILD ]
    if (
      sessions.length > 0 &&
      _.findIndex(hideFeatures, ["bsClass", "schedule"]) === -1
    ) {
      options.push({ label: "Sessions", options: sessions });
    }

    return options;
  }

  onLinkChange(e) {
    //If in edit mode we will add the links directly to server...
    if (!this.props.toAddNewBooth) {
      this.props.addBoothLink(
        this.props.session,
        {
          ...e.value,
          interactivemapid: this.props.selectedMap.interactivemapid,
          locationid: this.props.booth.locationid,
          eventid: this.props.session.eventid,
        },
        e.value.type,
        (data) => {
          this.setState({
            links: [
              ...this.state.links,
              { ...e.value, islocal: false, ...data },
            ],
          });
          this.props.change("links", null);
        },
        () => {
          throw new SubmissionError({
            links: "Failed to add link to the booth",
          });
        }
      );
    } else {
      this.setState({
        links: [...this.state.links, { ...e.value, islocal: true }],
      });

      this.props.change("links", null);
    }
  }

  onDelete(e) {
    if (!this.props.toAddNewBooth) {
      this.props.deleteBooth(this.props.session, this.props.booth, (result) => {
        if (!result.error) {
          this.props.closeBooth();
        }
      });
      /*confirmAlert({
        title: 'Delete',
        message: 'This will permanently delete the Booth. Continue?',
        confirmLabel: 'OK',
        cancelLabel: 'CANCEL',
        onConfirm: () => {
          this.props.deleteBooth(this.props.session,this.props.booth,(result)=>{
            if(!result.error){
              this.props.closeBooth();
            }
          });
        },
        onCancel: () => {}
      });*/
    }
  }

  renderBoothLinks(hideFeatures) {
    var items = [];
    this.state.links.map((link) => {
      /* [ WILL UNCOMMENT ON NEXT BUILD ] Dont delete */
      var keyVal = _.uniqueId(
        link.type === "session"
          ? link.sessionid
          : link.type === "speaker"
          ? link.speakerid
          : link.type === "sponsor"
          ? link.sponsorid
          : link.exhibitorid
      );

      /* This condition check is features are available for display or not */
      if (
        _.findIndex(hideFeatures, function (o) {
          return (
            o.bsClass === (link.type === "session" ? "schedule" : link.type)
          );
        }) === -1
      ) {
        items.push(
          <BoothLink
            key={keyVal}
            boothLink={link}
            selectedMap={this.props.selectedMap}
          />
        );
      }
    });

    return items;
  }

  render() {
    var optionItems = this.renderOptions();

    var { handleSubmit, invalid, pristine, submitting } = this.props;

    var heading = "Add Booth";

    if (!this.props.toAddNewBooth) {
      heading = "Edit Booth";
    }

    var styles = reactCSS({
      default: {
        color: {
          width: "40px",
          height: "20px",
          border: "5px",
          background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
        },
        swatch: {
          padding: "3px 6px 9px 6px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer",
          // margin: "-27px 0px 0px 25px",
          // float: "left",
          // position: "relative",
        },
        popover: {
          position: "absolute",
          zIndex: "2",
        },
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px",
        },
      },
    });

    return (
      <div className="booth-editor">
        <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
          <div className="booth-backdrop"></div>
          <div className="booth-container animated slideInRight">
            <div className="booth-header">{heading}</div>
            <div className="booth-body">
              <Field
                name="locationname"
                label={LocaleStrings.map_label_boothname}
                placeholder={LocaleStrings.map_placeholder_boothname}
                type="text"
                mandatory="true"
                component={this.renderFieldText}
              />
              <Field
                name="boothno"
                label={LocaleStrings.map_label_boothnumber}
                placeholder={LocaleStrings.map_placeholder_boothnumber}
                type="text"
                mandatory="true"
                component={this.renderFieldText}
              />
              <Field
                name="color"
                label={LocaleStrings.map_label_boothcolor}
                placeholder={LocaleStrings.map_placeholder_boothcolor}
                type="text"
                mandatory="true"
                component={this.renderColorTextField}
                styles={styles}
                // onClick={this.handlePickerClick.bind(this)}
                managePicker={this.handlePickerClick.bind(this)}
              />
              {/* <div style={styles.swatch}>
                <button
                  style={styles.color}
                  type="button"
                  onClick={this.handlePickerClick.bind(this)}
                ></button>
              </div> */}
              {this.state.displayColorPicker ? (
                <div style={styles.popover}>
                  <div
                    style={styles.cover}
                    onClick={this.handlePickerClose.bind(this)}
                  />
                  <ColorPicker
                    color={this.state.color}
                    onChange={this.handlePickerChange.bind(this)}
                  />
                </div>
              ) : null}

              <Field
                name="links"
                label={LocaleStrings.map_label_searchandlinkbooth}
                mandatory="false"
                component={this.renderSelectPicker}
                opts={optionItems}
                onChange={this.onLinkChange.bind(this)}
              />
              <div className="form-group-map formdiv-map booth-links">
                {this.renderBoothLinks(hideFeatures)}
              </div>
            </div>

            {this.props.toAddNewBooth ? (
              <div className="booth-footer">
                <Button
                  className="button-theme map-button booth-button button-theme-blue"
                  disabled={pristine || invalid || submitting}
                  loading={this.state.loading}
                  type="submit"
                >
                  {LocaleStrings.button_save}
                </Button>
                <Button
                  className="button-theme map-button booth-button"
                  type="button"
                  onClick={this.onCancel.bind(this)}
                >
                  {LocaleStrings.button_cancel}
                </Button>
              </div>
            ) : (
              <div className="booth-footer">
                <Button
                  className="button-theme map-button booth-edit-button button-theme-blue"
                  disabled={pristine || invalid || submitting}
                  loading={this.state.loading}
                  type="submit"
                >
                  {LocaleStrings.button_save}
                </Button>
                <Button
                  className="button-theme map-button booth-edit-button btn-danger"
                  type="button"
                  onClick={this.onDelete.bind(this)}
                >
                  {LocaleStrings.button_delete}
                </Button>
                <Button
                  className="button-theme map-button booth-edit-button"
                  type="button"
                  onClick={this.onCancel.bind(this)}
                >
                  {LocaleStrings.button_cancel}
                </Button>
              </div>
            )}
          </div>
        </form>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  if (!values.locationname || values.locationname.trim() === "") {
    errors.locationname = LocaleStrings.map_validation_boothname;
  }

  if (!values.boothno || values.boothno.trim() === "") {
    errors.boothno = LocaleStrings.map_validation_boothnumber;
  }

  return errors;
}

function mapStateToProps(state) {
  //debugger;
  var booth;
  if (state.addEditBooth.toAddNewBooth) {
    booth = state.boothToAdd;
  } else {
    booth = state.boothToEdit;
  }
  return {
    session: state.session,
    toAddNewBooth: state.addEditBooth.toAddNewBooth,
    booth,
    initialValues: booth,
    boothlinks: state.imapResource.payload,
    boothLinkToDelete: state.deleteBoothLink.payload,
    selectedMap: state.selectediMap,
    interactivemaplocationsession: _.isEmpty(
      state.interactivemaplocationsession
    )
      ? []
      : state.interactivemaplocationsession,
    selectedFeatures: state.selectedFeatures,
    userEventDetails: state.userEventDetails,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  closeBooth,
  updateBoothColor,
  saveBooth,
  addBoothLink,
  deleteBooth,
  updateBooth,
  addBoothData,
  fetchInteractiveMapLocationSessionLinkWithEvventID,
})(
  reduxForm({
    form: "AddBoothForm",
    validate,
    enableReinitialize: true,
  })(BoothEditor)
);
